module.exports = __webpack_public_path__ + "static/media/bts_lalela_170711_027_small.33741597.jpg";